export const fonts = {
  body: 'Roboto, system-ui, sans-serif',
  heading: 'Roboto, system-ui, sans-serif',
  mono: 'Menlo, monospace',
};

export const fontWeights = {
  normal: 400,
  medium: 600,
  bold: 700,
};

export const fontSizes = {
  '3xl': '30px',
  '4xl': '38px',
  '5xl': '46px',
  '6xl': '60px',
};
